import CarDetailHeadline from '@components/CarDetailHeadline';
import { makeStyles, Paper } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    padding: theme.spacing(2),
    '& ul': {
      paddingLeft: theme.spacing(2),
    },
  },
}));

type CarDetailBulletListProps = {
  title: string;
  infoElements: string[];
  disableElevation?: boolean;
  className?: string;
};

const CarDetailBulletList = ({
  title,
  infoElements,
  disableElevation = false,
  className,
}: CarDetailBulletListProps) => {
  const classes = useStyles();

  return (
    <Paper elevation={disableElevation ? 0 : 3} className={clsx(classes.root, className)}>
      <CarDetailHeadline title={title} />

      <ul>
        {infoElements.map((info) => (
          <li key={info}>{info}</li>
        ))}
      </ul>
    </Paper>
  );
};

export default CarDetailBulletList;
